import {setOrFallbackValue} from './helper';
import CartItemStock from './cart_item_stock';
export default class CartItem {
    constructor(properties) {
        this.productCode = setOrFallbackValue(properties, 'productCode', null);
        this.price = setOrFallbackValue(properties, 'price', null);
        this.priceWithoutTax = setOrFallbackValue(properties, 'priceWithoutTax', null);
        this.inStock = setOrFallbackValue(properties, 'inStock', null);
        this.stockType = setOrFallbackValue(properties, 'stockType', null);
        this.itemStocks = ('' === setOrFallbackValue(properties, 'itemStocks', '')) ?
            [] : properties.itemStocks.map((stocks) => {return new CartItemStock(stocks);});

    }
}
